import React, { Component } from "react";
import { connect } from 'react-redux';
import { fromJS } from "immutable";
import { bindActionCreators } from 'redux'
import { toast } from "react-toastify";

import TextInputField from '../../infra/components/formInput/CustomTextInput' 
import ComboboxInput from '../../infra/components/formInput/ComboboxInput' 
import DatePickerInput from '../../infra/components/formInput/DatePickerInput'

import ActionAdd from '../../store/action/ReportInteractive/Request'
import ActionGetAllUser from '../../store/action/Account/FetchAll'
import ActionGetAllClient from '../../store/action/Client/FetchAll'
import ActionGetAllDivision from '../../store/action/Division/FetchAll'
import ActionGetAllSender from '../../store/action/Sender/FetchAll'
import ActionEdit from '../../store/action/Supervisor/Edit'
import {IsEdit, IsCreate, IsView } from '../../store/constants'
import { ListReportType,ListTemplateType } from '../../store/local/list'
import moment from "moment";

class Form extends Component{

  constructor(props){
    super(props);
    this.state ={
      form : fromJS({
        'request-id' : '',
        'request-date' : '',
        'client-id' : '',
        'division-id' : '',
        'sender-id' : '',
        'template-id' : '',
        'start-date' : '',
        'end-date' : '',
        'msisdn':'',
        'type':'',
        'content':''
      }),
      loadded: false,
      disabled: false,
      errors: fromJS({}),
      error: '',
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
  }

  componentDidMount(){
    this.props.actionGetAllUser();
    this.props.actionGetAllClient();
    this.props.actionGetAllDivision();
  }

  handleChange(field, value, label) {
    var formVal = this.state.form;
    formVal = formVal.set(field,value); 
    
    if(field === 'client-id'){
      this.props.actionGetAllDivision(value);
      this.props.actionGetAllSender(value);
    }

    if(field === 'contact-msisdn'){
      if(!value.startsWith('62')){
        value = `62${value}`
      }
    }

    this.setState({ form:formVal })
  }

  async handleSubmit(dispatch) {
    const {form} = this.state;
    var isValid = true;
    const mandatoryField = fromJS(['client-id','start-date','end-date' ])
    
    var newErrors = fromJS({});
    mandatoryField.map((field) => {
        if(form.get(field) === ''){
          isValid = false;
          newErrors = newErrors.set(field)
        }
    })

    this.setState({ errors: newErrors })

    if(!isValid){
      toast.error("Mandatory Field Cannot Empty!",toast.POSITION.TOP_RIGHT)
    }

    if(isValid){

      switch(this.props.actionType) {
        case IsCreate:
            await this.SubmitNewData();
          break;
        default:
          // code blocks
      }  

    }
  }

  async SubmitNewData(){
    const form = this.state.form;
    var data =  
        {'filter' : 
            {
                'spv-name' : form.get('spv-name'),
                'client-id' : form.get('client-id'),
                'division-id' : form.get('division-id'),
                // eslint-disable-next-line radix
                'sender-id' : form.get('sender-id')=='' ? "":parseInt(form.get('sender-id')),
                'start-date' : `${form.get('start-date')} 00:00:00`,
                'end-date' : `${form.get('end-date')} 23:59:59`,
                'msisdn': form.get('msisdn'),
                'type': form.get('type'),
                'content': form.get('content')
            }
        };

        var response = await this.props.actionAdd(data);
        if(response.ok){
          toast.success('Save Success!', toast.POSITION.TOP_RIGHT);
          this.props.handleCancelForm(true); 
        }else{
          toast.error('Save Failed', toast.POSITION.TOP_RIGHT);
        }
  }
  
  handleCancel(){
    this.props.handleCancelForm(false);  
  }

  componentWillMount(){
    if(this.props.item != null || this.props.item !== undefined){
      if((this.props.actionType === IsCreate) && !this.state.loadded){
        this.setState({
          form:  fromJS({
            'client-id' : '',
            'division-id' : '',
            'sender-id' : '',
            'template-id' : '',
            'start-date' : '',
            'end-date' : '',
            'msisdn':'',
            'type':'',
            'content':''
          }),
          loadded: true,
          disabled: (this.props.actionType === IsView),
        })  
      }
    }
  }

  render(){
    const { form, errors, disabled } = this.state;
    return (
      <div className="card no-margin-bottom">
      <div className="body">
        <div className="row no-margin-bottom">
              <span className="col-sm-2">Client *</span>
              <div className="col-sm-10">
                  <ComboboxInput
                    field='client-id'
                    value={form.get('client-id')}
                    options={fromJS({
                        'source': this.props.clientall,
                        'value': 'client-id',
                        'label': 'client-name'
                    }) }
                    onChange={(field, value, label) => this.handleChange(field,value,label)}
                    placeholder="Client"
                    disabled={this.state.disabled}
                    hasError={errors.has('client-id')}
                />  
              </div>
          </div>

          <div className="row no-margin-bottom">
              <span className="col-sm-2">Division *</span>
              <div className="col-sm-10">
                  <ComboboxInput
                    field='division-id'
                    value={form.get('division-id')}
                    options={fromJS({
                        'source': this.props.divisionall,
                        'value': 'division-id',
                        'label': 'division-name'
                    }) }
                    onChange={(field, value, label) => this.handleChange(field,value,label)}
                    placeholder="Division"
                    disabled={this.state.disabled}
                    hasError={errors.has('division-id')}
                />  
              </div>
          </div>

          <div className="row no-margin-bottom">
              <span className="col-sm-2">Sender *</span>
              <div className="col-sm-10">
               <ComboboxInput
                    field='sender-id'
                    value={form.get('sender-id')}
                    options={fromJS({
                        'source': this.props.senderall,
                        'value': 'sender-id',
                        'label': 'sender-name'
                    }) }
                    onChange={(field, value, label) => this.handleChange(field,value,label)}
                    placeholder="Sender"
                    disabled={this.state.disabled}
                    hasError={errors.has('sender-id')}
                /> 
              </div>
          </div>

          <div className="row no-margin-bottom">
              <span className="col-sm-2">Start Date</span>
              <div className="col-sm-10">
                <DatePickerInput
                  dateFormat="yyyy-MM-dd"
                  convertvalue
                  field="start-date"
                  value={ form.get('start-date') }
                  onChange={(field, date) => this.handleChange(field, date)}
                  minDate={new Date(moment().subtract(3, "month").format("YYYY-MM-DD "))}
                  maxDate={new Date()}
                />
              </div>
          </div>

          <div className="row no-margin-bottom">
              <span className="col-sm-2">End Date</span>
              <div className="col-sm-10">
                <DatePickerInput
                  convertvalue
                  dateFormat="yyyy-MM-dd"
                  field="end-date"
                  value={ form.get('end-date') }
                  onChange={(field, date) => this.handleChange(field, date)}
                  // minDate={new Date(form.get('start-date'))}
                  minDate={new Date(moment().subtract(3, "month").format("YYYY-MM-DD "))}
                  maxDate={new Date()}
                />
              </div>
          </div>

          <div className="row no-margin-bottom">
              <span className="col-sm-2">MSISDN</span>
              <div className="col-sm-10">
                <TextInputField className="form-control"
                  field={'msisdn'}
                  value={ form.get('msisdn')}
                  onChange={(field, value) => this.handleChange(field,value)}
                  placeholder="msisdn"
                  disabled={ disabled }
                  hasError={errors.has('msisdn')}
                />
              </div>
          </div>

          <div className="row no-margin-bottom">
              <span className="col-sm-2">Type </span>
              <div className="col-sm-10">
                <ComboboxInput
                    field='type'
                    value={form.get('type')}
                    options={fromJS({
                        'source': ListReportType(),
                        'value': 'value',
                        'label': 'label'
                    }) }
                    onChange={(field, value, label) => this.handleChange(field,value, label)}
                    placeholder="Type"
                    disabled={this.state.disabled}
                    hasError={errors.has('type')}
                />  
              </div>
          </div>

          <div className="row no-margin-bottom">
              <span className="col-sm-2">Content </span>
              <div className="col-sm-10">
                <ComboboxInput
                    field='content'
                    value={form.get('content')}
                    options={fromJS({
                        'source': ListTemplateType(),
                        'value': 'value',
                        'label': 'label'
                    }) }
                    onChange={(field, value, label) => this.handleChange(field,value, label)}
                    placeholder="Content"
                    disabled={this.state.disabled}
                    hasError={errors.has('content')}
                />  
              </div>
          </div>
          {this.renderFormName(form, errors)} 

          <div className="row no-margin-bottom">
            <span className="col-sm-2"></span>
            <div className="col-sm-10">
            <button type="button"
                  className="btn btn-wide btn-danger"
                  value="Cancel"
                  onClick={ this.handleCancel }>
                    Cancel
              </button>
              <button type="button" 
                  className="btn btn-wide btn-success"
                  onClick={ this.handleSubmit }>
                    Submit
              </button>
            </div>
          </div>
        </div>
        </div>
    );
  }

  renderFormName(form, errors){
    if(this.props.actionType === IsEdit){
      return(
        <div className="row no-margin-bottom">
              <span className="col-sm-2">Name</span>
              <div className="col-sm-10">
                  <TextInputField className="form-control"
                      field={'spv-name'}
                      value={ form.get('spv-name')}
                      onChange={(field, value) => this.handleChange(field,value)}
                      placeholder="name"
                      hasError={errors.has('spv-name')}
                  />
              </div>
        </div>
      )
    }
  }

}

export default connect(
    (state) => {
        return {
            Users: state.user.users,
            userall: state.user.userall,
            clientall: state.user.clientall,
            divisionall: state.user.divisionall,
            senderall: state.user.senders,
        }
    },
    dispatch => bindActionCreators({
        actionAdd: ActionAdd,
        actionEdit: ActionEdit,
        actionGetAllUser: ActionGetAllUser,
        actionGetAllClient: ActionGetAllClient,
        actionGetAllDivision: ActionGetAllDivision,
        actionGetAllSender: ActionGetAllSender,
    }, dispatch),
  )(Form);